const Variants = ({variants = []}) => {
  if (!variants.length) {
    return null;
  }

  return (
    <div className="variants">
      {variants.map((variant, index) => (
        <div className="variants__item" key={index}>
          {variant}
        </div>
      ))}
    </div>
  );
}

export default Variants;
